import { Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Firestore, Timestamp, addDoc, collection } from '@angular/fire/firestore';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { UserFeedback } from '@nx-superprep/backend/firebase'

@Component({
  selector: 'pop-ui-feedback',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatSnackBarModule,
    MatIconModule
  ],
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FeedbackComponent {
  private firestore = inject(Firestore);
  private snackBar = inject(MatSnackBar);

  formData = {
    name: '',
    email: '',
    feedback: ''
  };

  isLoading = signal(false);
  close: (reason?: string) => void = () => { return }; // Will be set by modal service

  async submitFeedback() {
    if (!this.formData.name || !this.formData.email || !this.formData.feedback) {
      this.snackBar.open('Please fill all required fields', 'OK', { duration: 3000 });
      return;
    }

    this.isLoading.set(true);

    try {
      const feedback = new UserFeedback(
        this.formData.name,
        this.formData.email,
        'popstudy', // Hardcoded for PopStudy
        this.formData.feedback,
        new Date() as unknown as Timestamp
      );

      await addDoc(collection(this.firestore, 'user_feedbacks'),
        UserFeedback.converter.toFirestore(feedback));

      this.snackBar.open('Thanks for your feedback!', 'OK', { duration: 3000 });
      this.formData = { name: '', email: '', feedback: '' };
      this.close('success'); // Close modal on success
    } catch (error) {
      this.snackBar.open('Error submitting feedback', 'OK', { duration: 3000 });
      console.error(error);
    } finally {
      this.isLoading.set(false);
    }
  }

  onClose() {
    this.close('cancel');
  }
}
